'use client';

import type { ComponentProps } from 'react';
import { Avatar as BaseAvatar, AvatarStack as BaseAvatarStack } from '@church/nextjs-ui/website';

/**
 * The website kit's avatars, each wrapped as a personal fact (`.pii`) so a
 * demo with `?blur=1` blurs every face on the page in one place.
 */
export function Avatar(props: ComponentProps<typeof BaseAvatar>) {
  return (
    <span className="pii inline-flex shrink-0 rounded-full align-middle">
      <BaseAvatar {...props} />
    </span>
  );
}

export function AvatarStack(props: ComponentProps<typeof BaseAvatarStack>) {
  return (
    <span className="pii inline-flex shrink-0 align-middle">
      <BaseAvatarStack {...props} />
    </span>
  );
}
